import { createContext, useContext, useState, useEffect, useRef } from "react";

const ScrollContext = createContext();

export const useScroll = () => useContext(ScrollContext);
export const updateTranslateYWithScroll = (ref, scrollY) => {
  const dropDown = ref.current.querySelector(
    'ul[data-te-dropdown-menu-ref="true"]'
  );

  if (!dropDown) return;

  const styles = window.getComputedStyle(dropDown);

  const transform = styles.transform;
  let translateY = 0;

  if (transform.startsWith("matrix")) {
    const matrixValues = transform.match(/matrix.*\((.+)\)/)[1].split(", ");
    translateY = matrixValues[5];
  }
  dropDown.style.transform = `translateY(${
    Number(translateY) - scrollY + 20
  }px)`;
};
export const ScrollProvider = ({ children }) => {
  const [scrollY, setScrollY] = useState(0);
  let debounceTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }

      debounceTimeoutRef.current = setTimeout(() => {
        setScrollY(window.scrollY);
      }, 200);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  return (
    <ScrollContext.Provider value={{ scrollY }}>
      {children}
    </ScrollContext.Provider>
  );
};
